/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Link_CopiedInputs */

const en_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Copied!`)
};

const es_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Enlace copiado!`)
};

const fr_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien copié !`)
};

const de_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopiert!`)
};

const ja_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクをコピーしました！`)
};

const zh_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接已复制！`)
};

const ar_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم نسخ الرابط!`)
};

const id_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan Disalin!`)
};

const it_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Copiato!`)
};

const ru_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылка скопирована!`)
};

const pt_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Copiado!`)
};

const ko_action_link_copied = /** @type {(inputs: Action_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`링크가 복사되었습니다!`)
};

/**
* | output |
* | --- |
* | "Link Copied!" |
*
* @param {Action_Link_CopiedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_link_copied = /** @type {((inputs?: Action_Link_CopiedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Link_CopiedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_link_copied(inputs)
	if (locale === "es") return es_action_link_copied(inputs)
	if (locale === "fr") return fr_action_link_copied(inputs)
	if (locale === "de") return de_action_link_copied(inputs)
	if (locale === "ja") return ja_action_link_copied(inputs)
	if (locale === "zh") return zh_action_link_copied(inputs)
	if (locale === "ar") return ar_action_link_copied(inputs)
	if (locale === "id") return id_action_link_copied(inputs)
	if (locale === "it") return it_action_link_copied(inputs)
	if (locale === "ru") return ru_action_link_copied(inputs)
	if (locale === "pt") return pt_action_link_copied(inputs)
	return ko_action_link_copied(inputs)
});